<template>
  <div class="signup-email">
    <div class="auth-app-header">
      {{ $t("authentication-app.singup.heading") }}
    </div>

    <slot name="user-type" />

    <EmailInput
      :value="email"
      :error-message="errorMessage"
      :show-error="showErrorMessage"
      @valid="isSubmitDisabled = false"
      @invalid="isSubmitDisabled = true"
      @submit="handleSubmitEmail"
      @input="handleEmailInput"
    />

    <div class="auth-app-footer">
      <button
        :class="{ 'is-loading': isLoading }"
        :disabled="isSubmitDisabled"
        class="btn btn-primary btn-lg"
        @click="handleSubmitEmail"
      >
        {{ $t("authentication-app.buttons.continue") }}
      </button>

      <div class="auth-app-footer__secondary">
        <a
          href="#"
          @click.prevent="$emit('change-flow', 'login')"
          class="btn-link"
        >
          {{ $t("authentication-app.buttons.registered.title") }}
          <br />
          {{ $t("authentication-app.buttons.registered.cta") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import EmailInput from "../../components/EmailInput";
import AuthService from "../../services/auth";
import { Session } from "../../models/session";
import { TooEarlyError } from "../../models/auth-error";
import { sendGaEvent } from "@/services/dataLayerGaService";

export default {
  name: "SignupEmailView",

  components: {
    EmailInput,
  },

  props: {
    session: {
      type: Session,
      default: null,
    },
    userType: {
      type: String,
      required: true
    }
  },

  data: () => ({
    email: "",
    errorMessage: "",
    showErrorMessage: false,
    isSubmitDisabled: true,
    isLoading: false,
  }),

  methods: {
    handleEmailInput(email) {
      this.email = email;
      this.showErrorMessage = false;
    },

    handleSubmitEmail() {
      if (this.isSubmitDisabled || this.isLoading) {
        this.showErrorMessage = this.isSubmitDisabled;
        return;
      }
      this.isLoading = true;
      AuthService.startSession(this.email, this.$i18n.locale, '', null, false, null, this.userType)
        .then((session) => {
          sendGaEvent('email_enter');
          this.$emit("success", session);
        })
        .catch((error) => {
          this.isLoading = false;
          this.showErrorMessage = true;
          if (error instanceof TooEarlyError) {
            if (this.session !== null && this.session.isEmailSessionValid()) {
              return this.$emit("change-flow", "otp.email");
            }
            return (this.errorMessage = this.$t(
              `authentication-app.error.too-early`,
              {
                canBeResentAfter: error.getResendTimer(),
              }
            ));
          }
          const { statusCode, isCritical, message = '' } = error;
          if (typeof statusCode === "undefined" || isCritical) {
            this.showErrorMessage = false;
            return this.$emit("critical-error", error);
          }

          this.errorMessage = this.$t(`authentication-app.error.${statusCode}`, {
            error: message,
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/btn";
</style>
